export enum DialogActionType {
  Back = 'back',
  Cancel = 'cancel',
  Confirm = 'confirm',
  Submit = 'submit'
}
